import * as z from 'zod';

export const MainBreakerSchema = z.object({
  location: z.string().optional(),
  amperage: z.coerce.number().optional(),
  voltage: z.coerce.number().optional(),
});

export type MainBreaker = z.infer<typeof MainBreakerSchema>;
